import React from 'react'
import { Link } from 'react-router-dom'

import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { Mail } from 'react-feather'
import { Phone } from 'react-feather'

import siprc from '../../images/Affiliates/siprc.png'
import smart from '../../images/Affiliates/smartTrial.jpg'
import './Footer.css'

export const Footer = () => {
  const settings = {
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 10000,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 770,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  }

  return (
    <footer className="footer">
      <div className="footer-secondary">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12" style={{ cursor: 'grab' }}>
              <Slider {...settings}>
                <div>
                  <img
                    className="item affiliates"
                    alt="siprc logo"
                    src={siprc}
                    height={100}
                    width="auto"
                    style={{ margin: 'auto' }}
                  />
                </div>
                <div>
                  <img
                    className="item affiliates"
                    alt="shred logo"
                    src={smart}
                    height={100}
                    width="auto"
                    style={{ margin: 'auto' }}
                  />
                </div>
              </Slider>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-primary footer-background-color">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-4 footer-widget">
              <h5 className="heading text-white">
                Quick
                <span className="text-primary">
                  {" Links"}
                </span>
              </h5>
              <ul className="quick-links">
                <li>
                  <Link to="/about" className="btn-custom-muted">
                    About
                  </Link>
                </li>
                <li>
                  <Link to="/contact-us" className="btn-custom-muted">
                    Contact Us
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-lg-4 footer-widget">
              <h5 className="heading text-white">
                Contact
                <span className="text-primary">
                  {' '}Us
                </span>
              </h5>
              <address>
                <p className="text-primary">
                  SMART Concussion Trial
                </p>
                <span>
                  Research Coordinator,
                  <br />
                  Cubicle B4-510-11,
                  <br />
                  Alberta Children's Hospital,
                  <br />
                  28 Oki Drive NW
                  <br />
                  T3B 6A8
                </span>
                <br />
                <br />
              </address>
              <div
                style={{ display: 'flex', alignItems: 'center' }}
                className="text-primary"
              >
                <Mail size={16} className="mr-2" />
                smartconcussion@ucalgary.ca
              </div>
              <div
                style={{ display: 'flex', alignItems: 'center' }}
                className="text-primary"
              >
                <Phone size={16} className="mr-2" />
                403.671.2852
              </div>
            </div>
            <div className="col-lg-4 footer-widget">
              <span className="copyright">
              &copy; Copyright SHRED 2022
            </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
